import {useContext, useState} from 'react';
import {useList} from 'react-use';
import log from 'loglevel';

import MapDrawMarkers from '../components/map-draw-markers';
import StatsGroup from "../components/stats-group";

import SitePlanContext from "../utils/siteplan-context";

const Markers = props => {
  const sitePlanContext = useContext(SitePlanContext);
  const [isHidden, {push, updateAt}] = useList([false]);

  const handleChange = (id, forceTrue) => {
    updateAt(id, forceTrue ? false : !isHidden[id]);
  }

  let totals = {};
  sitePlanContext.poiMarkers.forEach((item, i) => {
    if (!totals[item.name]) totals[item.name] = 0;
    totals[item.name]++;
  });

  const markerStats = [{
    type: "number",
    title: "Total",
    value: sitePlanContext.poiMarkers.length,
    unit: '',
    extra: null
  }];

  for (var key in totals)
  {
    markerStats.push({
      id:markerStats.length,
      type: "number",
      title: isHidden[markerStats.length] ? 'Hidden' : 'Visible',
      value: totals[key],
      unit: key,
      clickable: true,
      checked: !isHidden[markerStats.length],
      onClick:handleChange
    });
  }

  log.info('Drawing '+props.title);

  return (
    <>
      <section>
        <StatsGroup stats={markerStats} />
      </section>
      <section className="card">
        <MapDrawMarkers show={markerStats.map(item => (item.checked ? item.unit : false))} />
      </section>
    </>
  );
}

export default Markers;
